// tslint:disable:max-file-line-count
import { ECoworkingOfferType } from '@cian/api-models/partner-programs/v1/get-offers';
import { InlineText2 } from '@cian/ui-kit/typography';
import { IABExperiment } from '@cian/api-models/monolith-python/cian-api/site/v1/get-ab-experiments';
import { EMaxAuctionService } from '@cian/api-models/search-offers/v2/search-offers-desktop.data';
import { Button, ButtonTheme } from '@cian/button-component';
import { Config } from '@cian/config';
import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';
import { mergeStyles, numberToPrettyString } from '@cian/utils';
import * as PropTypes from 'prop-types';
import * as React from 'react';

import { CallbackModalContainer } from '../common/components/callback_modal';
import { Comments, ICommentsAPI } from '../common/components/comments';
import { Description } from '../common/components/description';
import { HiddenBaseLabel } from '../common/components/hidden_base_label';
import { HorizontalCard } from '../common/components/horizontal_card';
import { ILoginMotivationPopupAPI } from '../common/components/login_motivation_popup';
import { Map } from '../common/components/map';
import { SimplePhoneButton } from '../common/components/phone/simple_button';
import { IUserInfoAPI } from '../common/components/user-info-popup';
import { IOfferHelper, offerHelper } from '../presenter';
import { IComplaintsHelpers } from '../types/complaints';
import { IJsonQuery } from '../types/json-query';
import { IOffer, LandAreaUnitType, IOfferPhoto } from '../types/offer';
import { IUser } from '../types/user';
import { canUseHiddenBase } from '../utils/user';
import { Address } from './address';
import { StartChatPopup } from './chats';
import { Similar } from './similar';
import { TCommercialCardTracking } from './tracking';
import { UserInfo } from './user_info';
import { RightPanel } from '../common/components/RightPanel';
import { getAgentPhone } from '../utils/getAgentPhone';
import { TopButtons } from '../TopOfferCard/TopButtons';
import { HorizontalAgentBrand } from '../TopOfferCard/HorizontalAgentBrand';
import { PreviewPlaceholderIcon } from '../TopOfferCard/icons/PreviewPlaceholderIcon';
import { Photos } from '../offer-card/components/photos';
import { GalleryImage } from '../common/components/gallery/image';
import { GalleryItemPreloader } from '../common/components/gallery/preloader';
import { ExtendedOfferLabel } from '../common/components/ExtendedOfferLabel';
import { IButtonsAPI } from '../offer-card/components/buttons';
import { Tooltip } from '../common/components/tooltip/Tooltip';
import { InfoIcon } from '../common/components/tooltip/icons/Info';
import { AreaParts } from './area_parts';
import { getMultiPSNString } from './helpers';
import { AnalyticsButton } from '../common/components/AnalyticsButton';
import { ContactStatus } from '../common/components/ContactStatus';
import { getMinAreaPrice } from './area_parts/helpers';
import { CoworkingAmenities } from './CoworkingAmenities';
// TODO: если эксперимент заапрувиться, переименовать компонент по-настоящему
import { CoworkingWorkplacesCountSubtitle as CoworkingSubtitle } from './internal/components/CoworkingWorkplacesCountSubtitle';
import { getFormattedCoworkingTitle } from './internal/helpers/getFormattedCoworkingTitle';
import { IAbUseExperiment } from '../types/abUseExperiments';
import { isCoworkingCardDescriptionHidden, isFlexOfficeCardSameAsOffice, isOfficeInCoworkingTitle } from '../utils/isCoworkingExperiment';
import { getCommercialOwnerShieldVisible } from '../utils/getCommercialOwnerShieldVisible';
import { FromCommercialOwnerShield } from './FromCommercialOwnerShield';

export interface ICommercialCardAPI {
  onPageJumped(label?: string): void;
  onPhoneOpened?(): void;
  onPDFLinkClicked?(): void;
  onDocLinkClicked?(): void;
  onFavoriteChange(isFavorite: boolean): void;
  onPhotoSlideChangedOnce?(): void;
  onMapOpened?(): void;
  onMapClosed?(): void;
  onMenuOpened?(): void;
  onHideOffer?(): void;
}

export interface IAnalyticsPopupAPI {
  onButtonClick(): void;
}

export interface ICommercialCardCompoentsProps {
  buttons: IButtonsAPI;
  card: ICommercialCardAPI;
  comments: ICommentsAPI;
  loginMotivationPopup: ILoginMotivationPopupAPI;
  mortgageBanner?: React.ReactNode | undefined;
  tracking?: Partial<TCommercialCardTracking>;
  userInfo: IUserInfoAPI;
  favoritesLimitForUnauthUser?: number;
  analyticsPopup?: IAnalyticsPopupAPI;
  onOfferCardClick?(): void;
}

export interface ICommercialCardRequestProps {
  baseUrl: string;
  currentPath: string | undefined;
  currentSubdomain: string;
  experiments: IABExperiment[];
  abUseExperiments?: IAbUseExperiment[];
  isBot: boolean;
  isSimilar: boolean;
  jsonQuery: IJsonQuery;
  offer: IOffer;
  qsToUris?: { [key: string]: string; };
  suggestionDistancesSeoText: string | undefined;
  user: IUser;
  defaultPhone?: string;
  defaultEmail?: string;
}

export interface ICommercialCardProps extends ICommercialCardRequestProps {
  api: ICommercialCardCompoentsProps;
  httpApi: IHttpApi;
  logger: ILogger;
  defaultPhone?: string;
  defaultEmail?: string;
  showPushNotification?: boolean;
  isOnHideAnimation?: boolean;
  isHideOfferFetching?: boolean;
  complaintsHelpers: IComplaintsHelpers;
  config: Config;
  /** Перечень регионов ранжированного поиска */
  mlSearchRegions?: number[];
  /** ML-ранжирование, без проверки региона  */
  isMlSearchForAll?: boolean;
  /** Максимальная ставка по аукциону в выдаче */
  maxAuctionBet?: number;
  /** Максимальная услуга выдачи */
  maxAuctionService?: EMaxAuctionService;
  /** Возможность получить ссылку на контейнер */
  containerRef?: React.RefObject<HTMLDivElement>;
  CoworkingProfitBanner?: React.ComponentType;
  isOfficeSearch?: boolean;
}

type TOfferMiniPhoto = IOfferPhoto | null;

export interface ICommercialCardState {
  galleryControlsHidden: boolean;
  isPhotoSlideChanged: boolean;
  animateHide: boolean;
  isHidden: boolean;
  isCommentAreaOpened: boolean;
  isCallbackModalOpened: boolean;

  // Menu
  isReportActive: boolean;
  isMapActive: boolean;
  isMoreActive: boolean;
  isReporting: boolean;

  isMount: boolean;

  previewPhotos: TOfferMiniPhoto[];
  otherPhotosCount: number;
  knAuctionCompanies?: number[];
}

export interface ICommercialCardContext {
  api: ICommercialCardCompoentsProps;
  baseUrl: string;
  currentSubdomain: string;
  experiments: IABExperiment[];
  abUseExperiments?: IAbUseExperiment[];
  httpApi: IHttpApi;
  isSimilar: boolean;
  // TODO: временное решение
  jsonQuery: IJsonQuery;
  logger: ILogger;
  offer: IOffer;
  offerHelper: IOfferHelper;
  user: IUser;
  /** Перечень регионов ранжированного поиска */
  mlSearchRegions: number[] | null;
  /** ML-ранжирование, без проверки региона  */
  isMlSearchForAll: boolean | null;
  /** Максимальная ставка аукциона на выдаче */
  maxAuctionBet?: number;
  /** Максимальная услуга выдачи */
  maxAuctionService?: EMaxAuctionService;
  /** Минимальная ставка для Московского региона */
  auctionMinBet?: number;
  /** Максимальная разрешённая ставка аукциона */
  auctionMaxBet?: number;
  /** Валидировать ли шаг ставки */
  validateStep: boolean;
}

const commonStyle = require('./index.css');
const style = require('./commercial_card.css');
const topOfferStyles = require('../TopOfferCard/TopOfferCard.css');
const offerStyles = require('../offer-card/offerCard.css');

const prepareDescription = (str: string | undefined) => str
  // 264 - максимальное количество символов, которые влезают в три строки
  ? str.length >= 264 ? str.slice(0 , 264).replace(/\W$/, '').trim().concat('...') : str
  : '';

const getCommercialLandTitleArea = (area: string | number | null, unitType: LandAreaUnitType | null) =>
  area ? `${parseFloat(area as string)} ${unitType === 'sotka' ? 'сот.' : 'га.'}` : '';

const getCommercialTotalArea = (totalArea: string | null, units: string) => totalArea ? `${totalArea} ${units}` : '';

export class CommercialOfferCard extends React.Component<ICommercialCardProps, ICommercialCardState> {
  // tslint:disable-next-line:no-any
  public static childContextTypes: { [key in keyof ICommercialCardContext]: PropTypes.Requireable<any> } = {
    api: PropTypes.object,
    baseUrl: PropTypes.string,
    currentSubdomain: PropTypes.string,
    experiments: PropTypes.array,
    abUseExperiments: PropTypes.array,
    httpApi: PropTypes.object,
    isMlSearchForAll: PropTypes.bool,
    isSimilar: PropTypes.bool,
    jsonQuery: PropTypes.object,
    logger: PropTypes.object,
    mlSearchRegions: PropTypes.array,
    offer: PropTypes.object,
    offerHelper: PropTypes.object,
    user: PropTypes.object,
    maxAuctionBet: PropTypes.number,
    maxAuctionService: PropTypes.string,
    auctionMinBet: PropTypes.number,
    auctionMaxBet: PropTypes.number,
    validateStep: PropTypes.bool,
  };

  public getChildContext(): ICommercialCardContext {
    const {
      config,
      api,
      baseUrl,
      currentSubdomain,
      experiments,
      abUseExperiments,
      httpApi,
      isSimilar,
      jsonQuery,
      logger,
      offer,
      user,
      maxAuctionBet,
      maxAuctionService,
    } = this.props;

    const auctionMaxBet = offer.auction ? offer.auction.maxAvailableBet : 99;
    const auctionMinBetForMoscowRegion = Number(config.get<string>('auction.minBetForMoscowRegion'));
    const regionId = offer.geo && offer.geo.address && offer.geo.address.length ? offer.geo.address[0].id : 0;
    const isMoscowRegion = [1, 4593].includes(regionId);
    const auctionMinBet = isMoscowRegion ? auctionMinBetForMoscowRegion : 1;

    return {
      api: {
        ...api,
        buttons: {
          onPopupMoreOpen: () => {},
          onPopupReportOpen: () => {},
          onPopupMoreClose: () => {},
          onPopupReportClose: () => {},
          onHideOffer: api.card.onHideOffer || (() => {}),
        },
      },
      baseUrl,
      currentSubdomain,
      experiments,
      abUseExperiments,
      httpApi,
      isMlSearchForAll: config.get<boolean>('isMlSearchForAll.Enabled') || false,
      isSimilar,
      jsonQuery,
      logger,
      mlSearchRegions: config.get<number[]>('mlSearchRegions') || [],
      offer,
      offerHelper: offerHelper(offer),
      user,
      maxAuctionBet,
      maxAuctionService,
      auctionMinBet,
      auctionMaxBet,
      validateStep: config.get<boolean>('validateStep') || false,
    };
  }

  public constructor(props: ICommercialCardProps) {
    super(props);

    const { offer: { photos } } = props;

    /* Берем фото для превью с 1 по 5 */
    const miniPreviewPhotos: TOfferMiniPhoto[] = photos.slice(1, 5);
    /* Сохраняем, сколько фото действительно есть, чтобы реализовать плейсхолдеры */
    const previewPhotosLength = miniPreviewPhotos.length;
    /* Нам нужно 4 превью в виде фото или плейсхолдера */
    miniPreviewPhotos.length = 4;
    /* Заполняем массив до конца плейсхолдерами (null отрендерится как пустое фотое) */
    miniPreviewPhotos.fill(null, previewPhotosLength, 4);

    this.state = {
      animateHide: false,
      galleryControlsHidden: true,
      isCallbackModalOpened: false,
      isCommentAreaOpened: false,
      isHidden: false,

      isReportActive: false,
      isMapActive: false,
      isMoreActive: false,
      isPhotoSlideChanged: false,
      isReporting: false,

      isMount: false,

      previewPhotos: miniPreviewPhotos,
      otherPhotosCount: photos.length - 4,
      knAuctionCompanies: this.props.config.get<number[]>('kn_auction_companies') || [],
    };
  }

  public componentDidMount() {
    this.setState({isMount: true});
  }

  public render() {
    const { api: { tracking, comments }, offer, containerRef, CoworkingProfitBanner, jsonQuery } = this.props;
    const { previewPhotos, otherPhotosCount } = this.state;
    const agentPhone = getAgentPhone(offer);
    const isRepresentative = !!(offer.businessShoppingCenter
      && offer.businessShoppingCenter.fromRepresentative);

    const leftPhoto = offer.photos.length > 1 ? offer.photos[1] : null;
    const rightPhoto = offer.photos.length > 2 ? offer.photos[2] : null;

    const isCommercialOwnerShieldVisible = getCommercialOwnerShieldVisible(offer, jsonQuery);

    return (
      <div
        {...mergeStyles(
          commonStyle['offer-container'],
          offer.isTop3 && commonStyle['offer-container--top3'],
          this.state.animateHide && commonStyle['offer--hide'],
          this.state.isHidden && commonStyle['offer--hidden'],
          this.props.isOnHideAnimation && commonStyle['hide-offer-animation'],
          !offer.isTop3 && !offer.isColorized && isRepresentative && commonStyle['represent'],
        )}
        ref={containerRef}
      >
        <HorizontalCard
          content={this.renderContent}
          containerStyle={mergeStyles(
            commonStyle['offer'],
            style['offer'],
            offer.isTop3 && commonStyle['offer--top3'],
            offer.isColorized && commonStyle['offer--colorized'],
          )}
          isPaid={offer.isPaid}
          isTop3={offer.isTop3}
          isColorized={offer.isColorized}
          isRepresentative={isRepresentative}
          mediaStyle={style['media']}
          onMouseEnter={this.onHoverOver}
          onTouchStart={this.onHoverOver}
          onMouseLeave={this.onHoverOut}
          onTouchMove={this.onHoverOut}
          media={(
            <div>
              {CoworkingProfitBanner && <CoworkingProfitBanner />}
              {isCommercialOwnerShieldVisible && (
                <FromCommercialOwnerShield className={style['from-commercial-owner']} />
              )}
            {offer.isTop3 ?
            <div className={topOfferStyles['media_brand_wrapper']}>
              <div className={topOfferStyles['media_wrapper']}>
                <div {...mergeStyles([
                    topOfferStyles['media'],
                    offer.photos.length <= 1 && topOfferStyles['media--big'],
                  ])}>
                  <Photos
                    offer={this.props.offer}
                    galleryControlsHidden={this.state.galleryControlsHidden}
                    photoContainerStyle={
                      mergeStyles(
                        topOfferStyles['photos_container'],
                        offer.photos.length <= 1 && topOfferStyles['photos_container--big'],
                      ).className
                    }
                    useThumbnail2Url={true}
                  />
                </div>
                {offer.photos.length > 1 &&
                  <div className={topOfferStyles['preview_photos']}>
                    {previewPhotos.map((photo, index) => {
                      if (!photo) {
                        return (
                          <div className={topOfferStyles['preview_placeholder']} key={index}>
                            <PreviewPlaceholderIcon />
                          </div>
                        );
                      }

                      return (
                        <div className={topOfferStyles['preview_photo']} key={index}>
                          {previewPhotos.length - 1 === index && otherPhotosCount > 1 &&
                            <div className={topOfferStyles['other_photos']}>
                              <div className={topOfferStyles['other_photos-content']}>
                                <div className={topOfferStyles['other_photos-text']}>Еще фото</div>
                              </div>
                            </div>
                          }
                          <GalleryItemPreloader>
                            <GalleryImage
                              src={photo.thumbnailUrl}
                              alt=""
                            />
                          </GalleryItemPreloader>
                        </div>
                      );
                      },
                    )}
                  </div>
                }
              </div>
              <div className={topOfferStyles['horizontal_agent_brand']}>
                <HorizontalAgentBrand />
              </div>
            </div>
            :
            <div {...mergeStyles([
              offerStyles['media'],
            ])}>
              <Photos
                offer={this.props.offer}
                galleryControlsHidden={this.state.galleryControlsHidden}
                photoContainerStyle={offer.isTop3 ? offerStyles['photos-container'] : ''}
                layoutPhotoStyle={offer.fromDeveloper ? offerStyles['layout_image'] : undefined}
              />
              {offer.isTop3 &&
              <div className={offerStyles['additional-photos']}>
                {leftPhoto &&
                <div className={offerStyles['left-photo']}>
                  <GalleryItemPreloader>
                    <GalleryImage
                      src={leftPhoto.thumbnailUrl}
                      alt=""
                    />
                  </GalleryItemPreloader>
                </div>
                }
                {rightPhoto &&
                <div className={offerStyles['right-photo']}>
                  <GalleryItemPreloader>
                    <GalleryImage
                      src={rightPhoto.thumbnailUrl}
                      alt=""
                    />
                  </GalleryItemPreloader>
                </div>
                }
              </div>
              }
            </div>
            }
            </div>
          )}
        />

        {offer.geo && offer.geo.coordinates && this.state.isMapActive &&
          <Map coordinates={offer.geo.coordinates}/>}

        {(this.state.isCommentAreaOpened || offer.notes.offer || offer.notes.realtor) &&
          <Comments
            offer={offer}
            isSimplified
            onCompletion={this.handleCommentingCompletion}
            {...comments}
          />}

        {!!offer.allFromOffrep && !!offer.allFromOffrep.count && !!offer.allFromOffrep.url &&
          <Similar
            isColorized={offer.isColorized}
            isTop3={offer.isTop3}
            count={offer.allFromOffrep.count}
            url={offer.allFromOffrep.url}
            trackAllDuplicatesClick={tracking ? tracking.trackAllDuplicatesClick : undefined}
            agencyName={offerHelper(offer).presenters.getAgentName()}
            accountType={offerHelper(offer).presenters.getAccountType()}
          />
        }

        {this.state.isCallbackModalOpened && !!agentPhone &&
          <CallbackModalContainer
            useOldWidget={true}
            gaLabel={offer.gaLabel || ''}
            agentPhone={agentPhone}
            callFrom="10:00"
            callTo="18:00"
            isAvailableToCall={true}
            timezoneText=""
            close={this.toggleCallbackModal}
            httpApi={this.props.httpApi}
          />
        }
      </div>
    );
  }

  public renderContent = () => {
    const { offer, user, config, api: { onOfferCardClick } } = this.props;
    const { extensionLabels } = offer;
    const areaParts = offer.areaParts;

    let showAnalyticsButton: boolean = config.get<boolean>('analyticButton.enabled') || false;
    showAnalyticsButton = showAnalyticsButton && !!offer.showCommercialAnalytics;

    const isFlexOfficeCardSameAsOffice = this.getFlexOfficeCardSameAsOffice();
    const isCoworkingCardDescriptionHidden = this.isCoworkingCardDescriptionHidden();

    return (
      <div className={offer.isTop3 && style['content_wrapper']}>
        <div className={style['content']}>
         <div className={offer.isTop3 ? style['info'] : style['commonInfo']} onClick={onOfferCardClick}>
            {this.renderTitle()}
            <div>
              <Address
                containerStyle={style['address']}
                currentPath={this.props.currentPath}
                qsToUris={this.props.qsToUris}
                onJKLinkClicked={() => void 0}
                onPageJumped={this.props.api.card.onPageJumped}
                suggestionDistancesSeoText={this.props.suggestionDistancesSeoText}
                coworking={offer.coworking}
              />
              {canUseHiddenBase(user) && Boolean(offer.isInHiddenBase) &&
                <HiddenBaseLabel containerStyle={style['hidden_base_label']} />
              }
            </div>
            <ExtendedOfferLabel labels={extensionLabels} labelStyle={style['label']}/>
            {
              !isCoworkingCardDescriptionHidden && (
                <Description
                  isBot={this.props.isBot}
                  isRecidivist={offer.isRecidivist}
                  isExcludedFromAction={offer.isExcludedFromAction}
                  description={prepareDescription(offer.description)}
                  descriptionWordsHighlighted={offer.descriptionWordsHighlighted}
                  containerStyle={style[offer.isTop3 ? 'description-top' : 'description']}
                  recidivistStyle={style['recidivist']}
                  excludedFromActionStyle={style['recidivist']}
                  onComplainStateChanged={this.onComplainStateChanged}
                  areaParts={areaParts}
                />
              )
            }
            {!isFlexOfficeCardSameAsOffice && offer.coworking && (
            <CoworkingAmenities
              {...offer.coworking}
              className={style['coworking-amenities']}
              url={offer.fullUrl}/>
            )}
          </div>
          <div {...mergeStyles(offer.isTop3 && style['agent_brand_wrapper'])}>{this.renderAutorInfo()}</div>
        </div>
        <div className={style['bottom-wrapper']}>
          {areaParts && areaParts.length > 0 && (
            <AreaParts
              areaParts={areaParts}
              offer={offer}
              onPageJumped={this.props.api.card.onPageJumped}/>
          )}
          {showAnalyticsButton && (
            <AnalyticsButton onClick={this.onAnalyticsButtonClick} />
          )}
          <div {...mergeStyles(style['footer'], offer.isTop3 && style['footer-top'])}>
            {this.renderFooterPanel()}
            <div className={commonStyle['footer-flags']}>
              <RightPanel />
            </div>
          </div>
        </div>
      </div>
    );
  }

  private handleHideFromPrintClick() {
    const { tracking } = this.props.api;

    this.setState({animateHide: true});

    if (tracking && tracking.trackHidePrintButtonClick) {
      tracking.trackHidePrintButtonClick();
    }

    setTimeout(() => {
      this.setState({isHidden: true});
    }, 500);
  }

  private renderFooterPanel() {
    const { offer, complaintsHelpers, isHideOfferFetching, isOnHideAnimation } = this.props;
    const isPhoneHidden = !!offer.kp && !offer.kp.displayBuilderPhone;

    return (
      <TopButtons
        position={0}
        isMapActive={this.state.isMapActive}
        onHideFromPrintClicked={this.handleHideFromPrintClick}
        onMapButtonClick={this.onMapButtonClick}
        isCallbackVisible={!!getAgentPhone(offer)}
        onCallbackClick={this.toggleCallbackModal}
        offer={offer}
        containerClassName={offerStyles['left-panel']}
        onCommentClick={this.handleCommentClick}
        buttonClassName={offerStyles['button']}
        dynamicButtonClassName={commonStyle['dinamic-buttons']}
        onFavoriteChange={(value: boolean) => this.props.api.card.onFavoriteChange(value)}
        isComplainOpen={this.state.isReportActive}
        onComplainClose={() => this.setState({isReportActive: false})}
        isSimilar={this.props.isSimilar}
        isPhoneHidden={isPhoneHidden}
        isMoreInfoHidden={true}
        isHideOfferFetching={isHideOfferFetching || isOnHideAnimation}
        isSimplified
        complaintsHelpers={complaintsHelpers}
      />
    );
  }

  private getOfficeInCoworkingTitleVisible = (): boolean => {
    const { abUseExperiments, isOfficeSearch, offer: { coworkingOfferType } } = this.props;

    if (!isOfficeSearch || coworkingOfferType !== ECoworkingOfferType.Office) {
      return false;
    }

    return isOfficeInCoworkingTitle(abUseExperiments);
  }

  private getFlexOfficeCardSameAsOffice = (): boolean => {
    const { abUseExperiments, isOfficeSearch, offer: { coworkingOfferType } } = this.props;

    if (!isOfficeSearch || coworkingOfferType !== ECoworkingOfferType.Office) {
      return false;
    }

    return isFlexOfficeCardSameAsOffice(abUseExperiments);
  }

  private isCoworkingCardDescriptionHidden = (): boolean => {
    const { abUseExperiments, isOfficeSearch, offer: { coworkingOfferType } } = this.props;

    if (!isOfficeSearch || coworkingOfferType !== ECoworkingOfferType.Office) {
      return false;
    }

    return isCoworkingCardDescriptionHidden(abUseExperiments);
  }

  private renderTitle() {
    const square = '\u00B2';
    const { offer, jsonQuery, isOfficeSearch } = this.props;
    const { cianUserId } = offer;
    const { knAuctionCompanies } = this.state;
    const { commercial, presenters } = offerHelper(offer);
    const isFlexOfficeCardSameAsOffice = this.getFlexOfficeCardSameAsOffice();
    const commercialTypeTitle = commercial.getType({
      isOfficeSearch,
      isOfficeInCoworkingTitleVisible: this.getOfficeInCoworkingTitleVisible(),
      isFlexOfficeCardSameAsOffice,

    });

    const term = (() => {
      switch (offer.dealType) {
        case 'rent':
          return presenters.getCommercialRentPrice();

        case 'sale': {
          const totalArea = parseFloat(offer.totalArea);

          if (offer.bargainTerms.priceType === 'squareMeter' && totalArea > 0) {
            return presenters.getSalePriceWithTotalArea();
          }

          return presenters.getSalePrice();
        }

        default:
          return presenters.getSalePrice();
      }
    })();

    const formattedTerm = term ? `за ${term}` : '';

    const minTerm = offer.dealType === 'rent' ? presenters.getCommercialMinRentPrice() : presenters.getMinSalePrice();
    let subTerm = offer.dealType === 'rent'
      ? commercial.isCommercialLand()
        ? commercial.getCommercialLandPerMeterByYear() : presenters.getCommercialPerMeterByYear()
      : presenters.getSalePricePerMeter();
    const classType = commercial.getBuildingClassType();
    const minArea = !commercial.isCommercialLand() && presenters.getMinArea()
     ? `${presenters.getMinArea()} м${square}` : null;

    const totalArea = commercial.isCommercialLand()
     ? `${getCommercialLandTitleArea(commercial.getCommercialLandArea(), commercial.getCommercialLandUnitType())}`
     : getCommercialTotalArea(presenters.getTotalArea(), `м${square}`);

    const minAreaMaxArea = minArea && totalArea ? `от ${minArea} до ${totalArea}` : totalArea;
    const vatPrice = commercial.getVatTypeWithVatPrice();
    let tooltipView;
    let textAuction = '';
    let textPSN = '';
    const cardTracking = this.getChildContext().api.tracking;

    const isPriceShow = knAuctionCompanies && !!cianUserId && !knAuctionCompanies.includes(cianUserId);

    if (!isPriceShow) {
      let trackTradePopupShow;
      let trackTradePopupClick;
      if (cardTracking) {
        trackTradePopupShow = cardTracking.trackTradePopupShow;
        trackTradePopupClick = cardTracking.trackTradePopupClick;
      }
      textAuction = ' · Электронные торги';
      tooltipView = !isPriceShow && (
        <Tooltip
          onOpen={trackTradePopupShow}
          customStyles={{
            display: 'inline-flex',
            verticalAlign: 'bottom',
          }}
          text={<span />}
          icon={<InfoIcon size={20}/>}
          iconColor="#2b87db"
          iconSize={20}>
          Объект реализуется через проведение торгов в соответствии с ГК РФ.&nbsp;
          <a href="https://cian.zendesk.com/hc/ru/articles/360037867052"
             target="_blank"
             onClick={trackTradePopupClick}>
            Справочная информация
          </a>
        </Tooltip>
      );
    }

    if (offer.category !== undefined &&
      offer.category.startsWith('freeAppointmentObject') &&
      offer.specialty &&
      offer.specialty.specialties &&
      offer.specialty.specialties.length > 0) {
      textPSN = getMultiPSNString(jsonQuery, offer.specialty.specialties);
    }

    const isAreaParts = offer.areaParts && offer.areaParts.length > 0;
    let minAreaPrice;

    if (isAreaParts) {
      const { areaParts } = offer;

      let preparedByPrice;
      const isRent = offer.dealType === 'rent';
      if (isRent) {
        preparedByPrice = areaParts && areaParts.map(i => i.price && i.area && ((i.price * 12) / Number(i.area)));
      } else {
        preparedByPrice = areaParts && areaParts.map(i => i.price && i.area && (i.price / Number(i.area)));
      }

      minAreaPrice = getMinAreaPrice(areaParts, offer.bargainTerms.paymentPeriod);

      const minAreaPricem2 = Math.min.apply(null, preparedByPrice);
      const paymentPeriodTitle = isRent ? 'в год' : '';
      subTerm = `от ${numberToPrettyString(Math.round(minAreaPricem2))} ₽ за м\u00b2 ${paymentPeriodTitle}`;
    }

    const minTermView = isAreaParts && minAreaPrice ? minAreaPrice : minTerm;

    if (!!offer.coworkingOfferType && !isFlexOfficeCardSameAsOffice) {
      return this.renderCoworkingTitle(commercialTypeTitle, offer.coworkingOfferType);
    }

    return (
      <div className={style['header']}>
        <h3 className={style['header-title']}>
          {offer.title ? (
            <div>
              <a
                className={style['header-link']}
                href={offer.fullUrl}
                onClick={this.props.api.card.onPageJumped.bind(null, 'card_header_in_newlist')}
                target="_blank"
              >
                {`${offer.title}${textAuction}`}
              </a>
              {tooltipView}
              <div className={style['header-subtitle']}>
                {
                  minTerm && minAreaMaxArea
                    ? `${commercialTypeTitle} ${minAreaMaxArea} от ${minTerm}${textPSN}`
                    : `${commercialTypeTitle} ${totalArea}${isPriceShow ? ` ${formattedTerm}` : ''}${textPSN}`
                }
                &nbsp;
                {classType && (<span className={style['header-classType']}>Класс {classType}</span>)}
              </div>
            </div>
          ) : (
            <div>
              <a
                className={style['header-link']}
                href={offer.fullUrl}
                onClick={this.props.api.card.onPageJumped.bind(null, 'card_header_in_newlist')}
                target="_blank"
              >
                {
                  isPriceShow
                    ? minTerm && minAreaMaxArea && `${commercialTypeTitle} ${minAreaMaxArea} от ${minTermView}`
                    : `${commercialTypeTitle} ${minAreaMaxArea} ${textPSN}`
                }
                {
                  isPriceShow
                    ? (!minTerm || !minAreaMaxArea) && ` ${commercialTypeTitle} ${totalArea} ${formattedTerm}${textPSN}`
                    : textAuction
                }
              </a>
              {tooltipView}
              {classType && (
                <span className={style['header-subtitle']}>
                  <span className={style['header-classType']}>Класс {classType}</span>
                </span>
              )}
            </div>
          )}
        </h3>
        {isPriceShow && (
          <div className={style['header-subTerm']}>
            <ul className={style['header-subTerm-list']}>
              {vatPrice && <li className={style['header-subTerm-item']}>{vatPrice}</li>}
              {subTerm && <li className={style['header-subTerm-item']}>{subTerm}</li>}
            </ul>
          </div>
        )}
      </div>
    );
  }

  private renderCoworkingTitle(coworkingTitle: string, coworkingOfferType: ECoworkingOfferType): React.ReactNode {
    const { offer, api } = this.props;
    const { title, fullUrl, workplaceCount, bargainTerms, priceTotalPerMonthRur }  = offer;
    const { priceForWorkplace } = bargainTerms;

    const isOfficeSearchExperiment = this.getOfficeInCoworkingTitleVisible();
    const priceForWorkplaceForCoworkingSearch = isOfficeSearchExperiment ? null : priceForWorkplace;

    let formattedCoworkingTitle = getFormattedCoworkingTitle(
      coworkingOfferType,
      coworkingTitle,
      workplaceCount ?? null,
      priceForWorkplaceForCoworkingSearch ?? null,
    );

    if (isOfficeSearchExperiment && priceTotalPerMonthRur) {
      formattedCoworkingTitle += ` за ${numberToPrettyString(priceTotalPerMonthRur)} руб./мес.`;
    }

    return (
      <div className={style['header']}>
        <h3 className={style['header-title']}>
            <div>
              <a
                className={style['header-link']}
                href={fullUrl}
                onClick={api.card.onPageJumped.bind(null, 'card_header_in_newlist')}
                target="_blank"
              >
                {title || formattedCoworkingTitle}
              </a>
              {
                !!title && (
                  <div className={style['header-subtitle-coworking']}>
                    <InlineText2>{formattedCoworkingTitle}</InlineText2>
                  </div>
                )
              }
              <div className={style['header-subtitle-count']}>
                <CoworkingSubtitle
                  workplaceCount={workplaceCount || null}
                  coworkingOfferType={coworkingOfferType}
                  isOfficeSearchExperiment={isOfficeSearchExperiment}
                  priceForWorkplace={priceForWorkplace}
                />
              </div>
            </div>
        </h3>
      </div>
    );
  }

  private renderAutorInfo() {
    const { offer } = this.props;
    const onlineShowLabel = this.renderOnlineShowLabel();

    return (
      <div
        {...mergeStyles(
          style['author_info'],
          offer.isTop3 && style['author_info-top'],
          onlineShowLabel !== null && commonStyle['author_online-show'],
        )}
      >
        {onlineShowLabel}
        {this.renderPhoneButton()}
        {offer.user && <UserInfo containerStyle={style['user_info']} />}
      </div>
    );
  }

  private renderOnlineShowLabel() {
    const { offer, config } = this.props;
    const onlineShowEnabled = Boolean(config.get<boolean>('onlineShow.isEnabled'));
    const canShowOnline = onlineShowEnabled && Boolean(offer.user && offer.user.canShowOnline);

    return canShowOnline ? (
      <div className={commonStyle['online-show']}>
        <ContactStatus
          labelText="Онлайн-показ"
          tooltipTitle="Выбирайте не выходя из дома"
          tooltipText="Вам могут провести онлайн-показ объекта при помощи видеозвонка в WhatsApp, Viber, FaceTime или другой программы"
        />
      </div>
    ) : null;
  }

  // Телефон справа
  private renderPhoneButton() {
    const { api: { tracking }, offer, user, defaultPhone, defaultEmail, showPushNotification } = this.props;
    const { isMount } = this.state;
    const { chatId, id } = offer;

    const showChats = isMount &&
      offer.user &&
      offer.user.isChatsEnabled &&
      !chatId;

    const showChatDialogs = isMount &&
      offer.user &&
      offer.user.isChatsEnabled &&
      chatId;

    const canShowAvailability = offer &&
      offer.user &&
      offer.user.agentAvailability &&
      offer.user.agentAvailability.availableFrom &&
      offer.user.agentAvailability.availableTo;

    const phones = offerHelper(offer).presenters.getPhones();

    return phones ?
      <div className={style['chats_block']}>
        <StartChatPopup
          defaultPhone={defaultPhone}
          defaultEmail={defaultEmail}
          trackingLabel={offer.gaLabel}
          disabled={!(showChats && canShowAvailability)}
          isAuthorised={!!(user.isAuthenticated && canShowAvailability)}
          showPushNotification={showPushNotification}
        >
          <SimplePhoneButton
            phones={phones}
            onPhoneOpened={this.props.api.card.onPhoneOpened}
            containerStyle={style['phone']}
          />
        </StartChatPopup>
        {showChats &&
          <StartChatPopup
            defaultPhone={defaultPhone}
            defaultEmail={defaultEmail}
            trackingLabel={offer.gaLabel}
            isAuthorised={user.isAuthenticated}
            showPushNotification={showPushNotification}
          >
            <Button
              theme={ButtonTheme.Ghost}
            >
              Написать <span className={style['hideable']}>сообщение</span>
            </Button>
          </StartChatPopup>
        }
        {showChatDialogs &&
          <Button
            theme={ButtonTheme.Ghost}
            onClick={(e) => {
              e.preventDefault();
              if (tracking && tracking.trackGoToMessages) {
                tracking.trackGoToMessages();
              }
              window.location.href = `/dialogs/?offerId=${id}`;
            }}
          >
            Посмотреть <span className={style['hideable']}>сообщение</span>
          </Button>
        }
      </div>
    : null;
  }

  private onComplainStateChanged = (isReporting: boolean) => {
    this.setState({
      isMoreActive: true,
      isReporting,
    });
  }

  private handleCommentClick = () => {
    if (this.state.isCommentAreaOpened) {
      return;
    }

    this.setState({
      isCommentAreaOpened: true,
    });
  }

  private handleCommentingCompletion = () => {
    if (!this.state.isCommentAreaOpened) {
      return;
    }

    this.setState({
      isCommentAreaOpened: false,
    });
  }

  private onHoverOver = () => {
    this.setState({
      galleryControlsHidden: false,
    });
  }

  private onHoverOut = () => {
    this.setState({
      galleryControlsHidden: true,
    });
  }

  private onMapButtonClick = () => {
    const { isMapActive } = this.state;
    const { card } = this.props.api;

    this.setState({
      isMapActive: !isMapActive,
    });

    if (isMapActive && card.onMapClosed) {
      card.onMapClosed();
    } else if (!isMapActive && card.onMapOpened) {
      card.onMapOpened();
    }
  }
  /**
   * Open/close callback modal window
   */
  private toggleCallbackModal = () => {
    this.setState({
      isCallbackModalOpened: !this.state.isCallbackModalOpened,
    });
  }

  public onAnalyticsButtonClick = () => {
    if (this.props.api.analyticsPopup && this.props.api.analyticsPopup.onButtonClick) {
      this.props.api.analyticsPopup.onButtonClick();
    }
  }
}
